
    <div class="logo-section">
    <img src="/assets/images/CDS-logo.svg" />
    </div>

    <router-outlet></router-outlet>

